import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { combineLatest } from "rxjs";
import { take } from "rxjs/operators";
import { Store, createSelector, select } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

import { UserErrorsService } from "@app/user/user-core/services/user-errors.service";
import { TranslationService } from "@core/translation.service";
import { WorkflowRouteDto } from "@helper/abstraction/workflows";
import { ValidatorsUtil } from "@helper/validators-util";
import { notNull } from "@helper/operators";

export type ProxyMessagePopupForm = {
	login: string;
	password: string;
    message: string;
};

@Component({
    selector: "app-proxy-message-popup",
    templateUrl: "./proxy-message-popup.component.html",
    styleUrls: ["./proxy-message-popup.component.scss"]
})
export class ProxyMessagePopupComponent {
	public form?: FormGroup;
	public workflowRoute?: WorkflowRouteDto;
	public certificateType?: string | null;
	public name?: string;
	public mainStoreName = "user";

    constructor(
		public config: DynamicDialogConfig,
		public ref: DynamicDialogRef,
		private userErrorsService: UserErrorsService,
		private store: Store,
		private fb: FormBuilder,
		private translationService: TranslationService,
    ) {
		this.certificateType = sessionStorage.getItem("CertificateType");
		this.name = this.config?.data?.name;
		this.mainStoreName = this.config?.data?.mainStoreName ?? "user";
		this.setData();
		this.initForm();
		const selectUser = (appState: any): any => appState[this.mainStoreName];
		const selectCertificateName = createSelector(selectUser, (state: any): string | undefined => state?.userProfile?.certificateName);

		combineLatest(
			this.store.pipe(select(selectCertificateName)),
		).pipe(
			notNull(),
			take(1)
		).subscribe(([certificateName]) => {
			this.form?.patchValue({ login: certificateName });
		});
	}

	public confirm(form: FormGroup): void {
		ValidatorsUtil.triggerValidation(form);
		if (form.invalid) {
			this.userErrorsService.displayErrors(form, undefined, undefined, true);
			return;
		}
		let fV = form.getRawValue();
		for (let k in fV) {
			if (["", null, undefined].includes(fV[k])) {
				delete fV[k];
			}
		}
		this.ref.close(fV);
	}

    public getFieldTranslate(code: string): string {
        return this.translationService.getTranslation(code);
    }

    private initForm(): void {
		this.form = this.fb.group({
			message: [this.config.data?.form?.message ?? null, [Validators.required]],
			login: [this.config.data?.form?.login ?? null, [Validators.required]],
			password: [this.config.data?.form?.password ?? null, [Validators.required]],
		});
	}

	public close(): void {
		this.ref.close();
	}
	
	private setData(): void {
		this.config.header = $localize`Для доступа к контейнеру личного ключа введите пароль`;
		this.config.width = "600px";
		for (let k in this.config.data) {
			(this as any)[k] = this.config.data[k];
		}
	}
}
